import { Text } from '@gitbook/slate';

import type { HastToGastTransformFn } from './types';
import { sanitizeSpaces } from './utils';

/**
 * Transform a text node.
 */
export const transformTextNode: HastToGastTransformFn = async function transformTextNode(
    node,
    _eat,
    context
) {
    // @ts-expect-error
    const value = node.value;
    if (typeof value !== 'string') {
        return [];
    }

    const innerText = context.sanitizeSpaces !== false ? sanitizeSpaces(value) : value;
    if (innerText.length === 0) {
        return [];
    }

    return [Text.create({ text: innerText, marks: context.marks })];
};
